import React, { useRef, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Card, Select, Flex } from "antd";
import "./LineChart.scss";

const LineChart = ({
  title,
  categories,
  seriesData,
  dropdownOptions,
  selectedOption,
  onChange,
}) => {
  const chartRef = useRef(null);
  const [visibleSeries, setVisibleSeries] = useState(
    seriesData.map(() => true)
  );

  const toggleSeries = (index) => {
    const chart = chartRef.current;
    if (chart && seriesData[index]) {
      chart.toggleSeries(seriesData[index].name);
      setVisibleSeries((prev) => {
        const updated = [...prev];
        updated[index] = !updated[index];
        return updated;
      });
    }
  };

  const options = {
    chart: {
      type: "line",
      toolbar: { show: false },
      events: {
        mounted: (chartContext) => {
          chartRef.current = chartContext;
        },
      },
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    tooltip: {
      shared: true,
      custom: function ({ series, dataPointIndex, w }) {
        return `
          <div class="custom-tooltip">
            ${series
              .map((_, i) => {
                if (!visibleSeries[i]) return "";
                return `
                  <div class="tooltip-item">
                    <span class="color-dot" style="background-color: ${w.config.colors[i]}"></span>
                    <span class="tooltip-label">${w.globals.seriesNames[i]}</span>
                    <span class="tooltip-value">: ${series[i][dataPointIndex]}</span>
                  </div>
                `;
              })
              .join("")}
          </div>
        `;
      },
    },
    colors: ["#36A546", "#FFA52F", "#1F77F5"],
    xaxis: {
      categories: categories,
      labels: {
        style: { fontSize: "12px" },
      },
    },
    yaxis: {
      labels: {
        style: { fontSize: "12px" },
      },
    },
    legend: {
      show: false,
    },
    grid: {
      show: true,
      borderColor: "#EAEAEA",
    },
  };

  return (
    <Card
      style={{ borderRadius: "20px", padding: "20px" }}
      className="wrapper_of_linechart"
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h3 style={{ marginBottom: 0 }}>{title}</h3>
        <Select
          className="selectBox"
          defaultValue={selectedOption}
          style={{ borderRadius: "20px" }}
          options={dropdownOptions}
          onChange={onChange}
        />
      </div>

      <ReactApexChart
        options={options}
        series={seriesData}
        // series={seriesDataWithVisibility}
        type="line"
        height={230}
      />
      <Flex className="custom-legend-linechart">
        {seriesData.map((s, index) => (
          <div
            key={index}
            className="legend-item"
            onClick={() => {
              chartRef.current?.toggleSeries(s.name);
              setVisibleSeries((prev) => {
                const updated = [...prev];
                updated[index] = !updated[index];
                return updated;
              });
            }}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              cursor: "pointer",
              opacity: visibleSeries[index] ? 1 : 0.4,
            }}
          >
            <span
              className="color-dot"
              style={{
                width: "13px",
                height: "13px",
                borderRadius: "2px",
                backgroundColor: options.colors[index],
              }}
            />
            <span
              className="legend-label"
              style={{
                fontSize: "12px",
                fontFamily: "Gilroy",
                fontWeight: visibleSeries[index] ? "600" : "400",
                color: visibleSeries[index] ? "#212330" : "#000",
              }}
            >
              {s.name}
            </span>
          </div>
        ))}
      </Flex>
    </Card>
  );
};

export default LineChart;
